export const SITE_URL = 'https://fastaudio.cc'
export const SITE_NAME = 'FastAudio'
export const SITE_DESCRIPTION =
  'Free online downloader — convert YouTube, Instagram, TikTok and Facebook videos to MP3 audio or MP4 video. Up to 320kbps audio quality. No registration, no software needed.'

export const PAGES = {
  home: {
    title: `FastAudio — Free YouTube, TikTok, Instagram & Facebook to MP3 & MP4 Downloader`,
    description: SITE_DESCRIPTION,
    canonical: SITE_URL,
  },
  youtube: {
    title: `YouTube to MP3 & MP4 Downloader — Free, 320kbps, No Registration | FastAudio`,
    description:
      'Download any YouTube video as MP3 audio (up to 320kbps) or MP4 video for free. Supports YouTube Shorts, YouTube Music, long videos. No sign-up required.',
    canonical: `${SITE_URL}/youtube-downloader`,
    schema: 'youtube',
  },
  instagram: {
    title: `Instagram Reel & Video Downloader — Free MP3 & MP4 Download | FastAudio`,
    description:
      'Download Instagram Reels, posts and IGTV videos as MP3 audio or MP4 video for free. No login needed, no watermark, works directly in your browser.',
    canonical: `${SITE_URL}/instagram-downloader`,
    schema: 'instagram',
  },
  tiktok: {
    title: `TikTok to MP3 & MP4 Downloader — No Watermark, Free | FastAudio`,
    description:
      'Download TikTok videos as MP3 audio or MP4 video online for free. No watermarks, no ads, no registration. Paste any TikTok URL and save in seconds.',
    canonical: `${SITE_URL}/tiktok-downloader`,
    schema: 'tiktok',
  },
  facebook: {
    title: `Facebook Video Downloader — Save as MP3 & MP4, Free, HD | FastAudio`,
    description:
      'Download Facebook videos and Reels as MP3 audio (up to 320kbps) or MP4 video (SD/HD quality) for free. No Facebook account required, works on all devices.',
    canonical: `${SITE_URL}/facebook-downloader`,
    schema: 'facebook',
  },
}

export function buildConverterSchema(name, url, description) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name,
    url,
    description,
    applicationCategory: 'MultimediaApplication',
    operatingSystem: 'Any',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
  }
}

export function buildBreadcrumbSchema(currentName, currentUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: currentName,
        item: currentUrl,
      },
    ],
  }
}

export function buildFAQSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: a,
      },
    })),
  }
}

export function buildHowToSchema(name, steps) {
  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name,
    step: steps.map((s, i) => ({
      '@type': 'HowToStep',
      position: i + 1,
      name: s.title,
      text: s.text,
    })),
  }
}
